import { seoFilter } from '../../../helpers/seo';
import { codeToImageInfoMap } from '../../utils/categoryMediaMappings';

export const ogImage = (
	categoryCode: keyof typeof codeToImageInfoMap,
): string =>
	`https://media-api.xogrp.com/images/${codeToImageInfoMap[categoryCode].id}`;

export const categoryText = (
	category: Redux.Category,
	appliedFacetIds: string[],
): string =>
	seoFilter(category.code, appliedFacetIds, true) || category.plural.term;

export const pageTitle = (location: Redux.Location, seoCategory: string) => {
	return `${seoCategory} With Prices in ${location.city}, ${location.stateCode}`;
};
